const DEBUG = false;

/**
 * A custom logger that only outputs messages to the console if the DEBUG flag is true.
 * Errors are always logged regardless of the DEBUG flag.
 */
const logger = {
	log:   (...args) => DEBUG && console.log('[App]', ...args),
	error: (...args) => console.error('[App]', ...args),
};

/**
 * AnalyticsTracker class (Client-side proxy).
 * This class provides a simple API for tracking events. It forwards all requests
 * to the service worker for actual processing and buffering.
 */
export default class AnalyticsTracker {
	constructor() {
		if (!('serviceWorker' in navigator)) {
			console.warn('[Analytics] Service Worker not supported. Tracking will be disabled.');
			this.isSupported = false;
		} else {
			this.isSupported = true;
		}
	}

	/**
	 * Tracks a single event by sending it to the service worker.
	 * @param {object} event - The event data to track.
	 */
	trackEvent(event) {
		if (!this.isSupported) return;
		this.trackEvents([event]);
	}

	/**
	 * Tracks a batch of events by sending them to the service worker.
	 * @param {object[]} events - An array of event data objects.
	 */
	trackEvents(events) {
		if (!this.isSupported) return;
		this._postMessage({
			type:    'ANALYTICS_EVENTS',
			payload: events,
		});
		logger.log('[App] Sending batch of events to Service Worker:', events);
	}

	/**
	 * Helper to post a message to the active service worker.
	 * @param {object} message - The message to send.
	 * @private
	 */
	_postMessage(message) {
		navigator.serviceWorker.ready.then((registration) => {
			registration.active.postMessage(message);

			logger.log('[App] Message Sent To Service Worker:', message);
		});
	}
}
